import React from 'react';

import useStyles from './styles';

interface Props {
    logo: React.ReactNode;
    compact?: boolean;
    className?: string;
}

const CustomerItem: React.FC<Props> = ({ logo, compact = false, className }) => {
    const { classes, cx } = useStyles({ compact });
    return <div className={cx(classes.root, className)}>{logo}</div>;
};

export default CustomerItem;
